import * as React from "react";
import { Platform } from "utils/website";
import {
	TModule,
	TMagicBannerModule,
	TTextModule,
	TCountdownBannerModule,
	TBannerModule,
	TMultiProductModule,
	TMagicBannerTwoModule,
	TCouponGroupModule,
	CouponType,
} from "services/page/admin";
import { ModuleInteraction } from "services/page/common";
import { TModuleType } from "utils/playground";
import { getGetCoupons } from "utils/zeusFetch";
import { getValidModuleData, refreshModule } from "utils/playground/module";
import { sendPrmByUrl } from "utils/prm";
import { getSite } from "utils/url";
import { sendPrm } from "tyrande/lib/prm";
import {
	transformBanner,
	transformBanners,
	getCardBannerItemSize,
	transformStickTabBanners,
	isLinkHasNewWindow,
} from "../../utils/banner";
import { tranformCouponInfo } from "utils/playground/banner";

import { bannerPlaceholder, transformMagicLinks } from "utils/playground/banner";
import {
	transformProductModule,
	loadPoolByFront,
	fetchMProductCardStyle,
	placeholderGroup,
	fetchProductPosterRadio,
} from "utils/playground/product";
import { replaceUrlWithTag } from "utils/playground/url";
import { getLitbLangFn } from "utils/lang";
import { jumpToLogin } from "utils/url";
import { isUAT } from "utils/debug";
import {
	MMagicBanner,
	MNavigation,
	MTypography,
	MCountdownBanner,
	MCarouselBanner,
	MCudeBannerZoom,
	MCudeBannerBase,
	MNormalProduct as MProduct,
	SlidingCardBanner,
	RollableCardBanner,
	MStickBottomTab,
	MCouponCode,
} from "optimus-front";
import { ModuleLayoutStyle } from "optimus-front/lib/services/playground";
import { GetReceiveCouponResp } from "optimus-front/lib/utils/zeusFetch";

import { multilingualTextDisplay } from "utils/mutil-Language";
import Constant from "utils/isomorphismConstant";
import { SetLitbCtrTrackOnAction, SetLitbCtrTrackOnShow } from "utils/ctrTrack";
import { RuntimeProps } from "../../../index";

export interface CommonProps {
	id: string;
}

interface ModuleProps {
	index: number;
	stickToTop?: number;
	id?: string;
	positionId: string;
	activityId: string;
	pageId: string;
	moduleDetail: TModule;
	runtime: RuntimeProps;
}

export default function Module(props: ModuleProps) {
	const { positionId, index, moduleDetail, runtime } = props;
	// tslint:disable-next-line
	const { type, id, header, ui } = moduleDetail;
	const layout = {
		...moduleDetail.layout,
		gap: 0.5625,
		parentGap: 0.75,
	};
	const interaction = moduleDetail.layout?.interaction;

	const PrmCommonParams = {
		floor: index + 1,
		position: 1,
		platform: Platform.MWEB,
	};
	const moduleData: { [key: string]: any } = getValidModuleData(moduleDetail);
	let modProps: any = {
		key: positionId,
		positionId,
		online: true,
		stickToTop: props.stickToTop,
		placeholderBg: bannerPlaceholder,
		aTarget: isLinkHasNewWindow(runtime),
	};

	switch (type) {
		case TModuleType.TQuickNav:
			return (
				<MNavigation
					{...modProps}
					texts={moduleData?.texts}
					navFixed={layout?.stickToTop}
				/>
			);
		case TModuleType.TSwiper:
			const tBannerModule: TBannerModule = moduleData;
			const tBannerItems = (tBannerModule.elements || []).map((ele) => ele.items?.[0]);
			const tBanners = transformBanners(tBannerItems, { ...PrmCommonParams });
			if (interaction === ModuleInteraction.RollOver) {
				return (
					<RollableCardBanner
						cardBanners={[...tBanners]}
						{...modProps}
						viewMore={{ link: header.link, text: getLitbLangFn("View More") }}
					/>
				);
			}
			if (interaction === ModuleInteraction.SingleSliding) {
				const { itemHeight: cardHeight, itemWidth: cardWidth } = getCardBannerItemSize(
					tBanners?.[0]?.height,
				);
				return (
					<SlidingCardBanner
						{...modProps}
						cardBanners={[...tBanners]}
						cardSize={{ cardWidth, cardHeight }}
					/>
				);
			}
			if (interaction === ModuleInteraction.Zoom) {
				return <MCudeBannerZoom {...modProps} elements={[...tBanners]} />;
			}
			if (interaction === ModuleInteraction.ZoomSliding) {
				return <MCudeBannerBase {...modProps} elements={[...tBanners]} />;
			}
			return <MCarouselBanner {...modProps} elements={[...tBanners]} />;

		case TModuleType.TMagicBannerType:
			const magicModule: TMagicBannerModule = moduleData;
			const magicBanner = transformBanner({ ...magicModule.banner }, { ...PrmCommonParams });
			const magicModuleItems: any = transformMagicLinks(index, magicModule.items);

			return (
				<MMagicBanner
					{...modProps}
					banner={magicBanner}
					onClick={sendPrmByUrl}
					linkItems={magicModuleItems}
				/>
			);
		case TModuleType.TMagicBannerTwo:
			const magicTwoModule: TMagicBannerTwoModule = moduleData;
			const magicBannerTwo = transformBanner(
				{ ...magicTwoModule.banners[0] },
				{ ...PrmCommonParams },
			);
			const magicTwoModuleItems: any = transformMagicLinks(index, magicTwoModule.items);
			return (
				<MMagicBanner
					{...modProps}
					banner={magicBannerTwo}
					onClick={sendPrmByUrl}
					linkItems={magicTwoModuleItems}
				/>
			);
		case TModuleType.TMultiProductModuleType:
			const productModule: TMultiProductModule = moduleData;

			const { tagGroup, activeTab, nextItems } = transformProductModule(
				productModule.proModules,
				PrmCommonParams,
				ui,
			);
			const posterRadio = fetchProductPosterRadio(ui.shape);
			const isRollable = layout?.interaction === ModuleInteraction.RollOver;
			return (
				<MProduct
					{...modProps}
					posterRadio={posterRadio}
					productModules={nextItems}
					activeTab={activeTab}
					tagGroup={tagGroup}
					canScrollFixed={true}
					isRollable={isRollable}
					viewMore={getLitbLangFn("View More")}
					notUseQnparams={true}
					stylesForCard={fetchMProductCardStyle({
						col: layout.columnNum,
						shape: ui.shape,
					})}
					placeholderBg={placeholderGroup(ui.shape)}
					layout={{ ...layout }}

					layoutStyle={ModuleLayoutStyle.Tomato}
					onLoadPool={loadPoolByFront({
						prm: PrmCommonParams,
						ui,
						runtime: props.runtime,
					})}
					onClickTab={(MPIndex: number) => {
						replaceUrlWithTag(header.position, tagGroup[MPIndex]?.text.content);
					}}
					SetCtrTrackOnAction={(pos: string, pid: string) =>
						SetLitbCtrTrackOnAction({ cpid: pid, pos })
					}
					SetCtrTrackOnShow={(pos: string, pids: string[] = []) =>
						SetLitbCtrTrackOnShow({ pids: pids.join(","), pos })
					}
				/>
			);
		case TModuleType.TCountdownBanner:
			const countDownModule: TCountdownBannerModule = moduleData;
			const cBanner = transformBanner({ ...countDownModule.banner }, { ...PrmCommonParams });
			return (
				<MCountdownBanner
					{...modProps}
					banner={cBanner}
					timer={countDownModule.timer}
					actState={countDownModule.state as any}
					onRefresh={refreshModule(id, {
						runtime: props.runtime,
					})}
				/>
			);
		case TModuleType.TRichText:
			const textModule = moduleData as TTextModule;
			const textContent = multilingualTextDisplay(textModule, Constant.language);
			return (
				<MTypography {...modProps} bgColor={ui?.bgColor || "#fff"} content={textContent} />
			);
		case TModuleType.TStickBotomTab:
			const stickTabBanners = transformStickTabBanners(moduleData.icons, {
				...PrmCommonParams,
			});
			return <MStickBottomTab {...modProps} bgColor={ui?.bgColor} images={stickTabBanners} />;

		case TModuleType.TCoupon:
			const cpoponModule: TCouponGroupModule = moduleData;
			const {
				languageCode,
				currency,
				countryCode3,
				sessionZeusKey = "",
				sid,
				isInApp,
			} = props?.runtime;
			const couponProps = {
				...modProps,
				language: languageCode,
				spmClick: (order: number) => {
					sendPrm({
						site: getSite(),
						page: "65",
						part: index + 1,
						content: order + 1,
					});
				},
				type: moduleDetail?.module?.couponType || CouponType.ReceiveCoupon,
				getCoupons: (code: string): Promise<GetReceiveCouponResp> => {
					if (!!!sessionZeusKey) {
						return jumpToLogin(true, isInApp, isLinkHasNewWindow(runtime));
					}
					return getGetCoupons(
						{
							isUat: isUAT() ? "true" : undefined,
							campaign_key: code,
							sid,
							sessionkey: sessionZeusKey,
							language: languageCode,
							currency,
							country: countryCode3,
							client: "vela",
						},
						true,
					);
				},
				coupons: tranformCouponInfo(cpoponModule?.coupons),
				columnSize: moduleDetail.layout.columnNum,
			};
			return <MCouponCode {...couponProps} />;
		default:
			return null;
	}
}
